import styled, { css } from 'styled-components';

// Segmented-control estilo X/Twitter:
//   - wrapper capsule (border-radius 999 pra ficar redondinho)
//   - 2 metades internas, so a ativa colorida (filled solid)
//   - a outra fica transparente com texto muted
//
// flex-shrink: 0 + auto width (em vez de flex: 1 1 0) pra que cada
// pair use so a largura natural do seu conteudo — assim o
// flex-wrap do container pai (HeaderSlotRight) pode quebrar pra
// proxima linha quando viewport e estreito (sem isso, os 5 pairs
// dividem espaco e o ultimo fica cortado em vez de wrap).
export const Container = styled.div`
  display: flex;
  align-items: stretch;
  /* flex: 1 1 0 + min-width: 0 — cada par cresce proporcionalmente pra
     ocupar a largura disponivel da linha. Antes (flex: 0 0 auto) cada
     par tinha so a largura natural do conteudo, deixando espaco vazio
     a direita. Agora os 5 pares dividem o row em 5 colunas iguais
     que ESTICAM com a coluna pai. */
  flex: 1 1 0;
  min-width: 0;
  height: 24px;
  padding: 2px;
  border-radius: 999px;
  background: ${(props) =>
    props.theme.title === 'light'
      ? 'rgba(0, 0, 0, 0.035)'
      : 'rgba(255, 255, 255, 0.04)'};
  border: 1px solid var(--cco-line);
  gap: 2px;
`;

// Esqueleto compartilhado pelas duas metades. As metades sao flex:1
// dentro do Container, entao dividem o espaco do par igualmente. Em
// telas largas crescem; em telas estreitas reduzem (com truncamento
// elegante via ellipsis se realmente nao couber).
const halfBase = css`
  flex: 1 1 0;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 999px;
  /* 8px + letter-spacing reduzido + padding lateral menor: o label mais
     longo ("DESBLOQUEADO", 12 chars) passa a caber inteiro no par sem
     truncar com ellipsis na coluna estreita do header. */
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  transition: background 180ms ease, color 180ms ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
  line-height: 1;
`;

// Aplicado quando a metade esta ativa — bg solido + texto contrastante.
// Para light mode, texto fica preto sobre verde; pra dark, branco.
const activeStyles = (bgColor) => css`
  background: ${bgColor};
  color: ${(props) => (props.theme.title === 'light' ? '#0a0a0b' : '#ffffff')};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
`;

// Estado inativo (ghost) — transparente com texto muted.
const idleStyles = css`
  background: transparent;
  color: var(--cco-ink-mute);
  opacity: 0.75;
`;

// Metade esquerda (Enabled) — verde quando ativa (estado "positivo").
export const Enabled = styled.div`
  ${halfBase}
  ${({ active }) =>
    active ? activeStyles('var(--cco-green)') : idleStyles}
`;

// Metade direita (Disabled) — pode ser critica (vermelho FALHA/PARADO/
// BLOQUEADO) ou simetrica (verde AUTOMÁTICO/MANUAL/REMOTO/LOCAL).
export const Disabled = styled.div`
  ${halfBase}
  ${({ active, critical }) =>
    active
      ? activeStyles(critical ? 'var(--cco-red)' : 'var(--cco-green)')
      : idleStyles}
`;
